import styled from 'styled-components';
import { mediaMax, mediaMin } from 'themes/helpers';
import { Modal } from 'antd';
import { colors } from 'themes/colors';
import PageHeader from 'components/PageHeader';
import Container from 'components/Container';
import Button from 'components/Button';
import bgWhite from 'images/bg-white.jpg';
import bgBlue from './images/blue-bg.jpg';
import bgYellow from './images/yellow-bg.jpg';
import iconQuote from './images/icon-quote.svg';
import iconStar from './images/icon-star-rating.svg';
import bgHotels from './images/bg-white.jpg';
import border from './images/border.png';
import borderModal from './images/modal-border-top.png';

export const OfficialHotel = {};

OfficialHotel.Wrapper = styled.section`
  font-size: 10px;
  .asterisk {
    color: ${colors.primary};
  }
`;

OfficialHotel.Header = styled.header`
  background: ${colors.primary} url(${bgYellow});
  padding: 6em 3em;
  text-align: center;
  font-size: 10px;
  color: #202530;
  @media (max-width: 600px) {
    padding: 4em 2em;
    font-size: 8px;
  }
  @media (max-width: 480px) {
    font-size: 7px;
  }

  h1 {
    font-family: 'Poppins';
    font-size: 5em;
    font-weight: 700;
    line-height: 1.2;
  }
  h4 {
    font-size: 2.4em;
  }
`;

export const Perks = {};

Perks.Wrapper = styled.div`
  position: relative;
  border-bottom: solid 1px ${colors.primary};
  padding: 25px 30px 20px;
  background-size: cover;
  > div {
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
  }
  ${mediaMax.tablet`
    > div {
      flex-wrap: wrap;
    }
  `};
  ${mediaMax.phoneL`
    padding: 15px;
  `};
`;

Perks.Item = styled.div`
  display: flex;
  align-items: center;
  > img {
    margin-right: 10px;
    border-bottom-right-radius: 15px;
  }
  > div {
    color: #fcab01;
    font-size: 1.9em;
    font-weight: bold;
  }
  ${mediaMax.tablet`
    width: 50%;
    margin-bottom: 10px;
    > img {
      width: 60px;
      height: 60px;
    }
  `};
  ${mediaMax.phoneL`
    width: 100%;
    background: #FFF;
    border-radius: 16px 0 16px 0;
    border: 1px solid rgba(26,40,62,0.14);
    margin-bottom: 5px;
    &:last-child {
      margin: 0;
    }
    > img {
      width: 40px;
      height: 40px;
      border-bottom-right-radius: 0;
    }
  `};
`;

export const FeaturedHotel = {};

FeaturedHotel.Wrapper = styled.div`
  background: #fff repeat-x center top;
  padding: 40px 30px;
  > section {
    max-width: 1235px;
    margin: auto;
  }
  p.lead {
    color: rgb(252, 38, 39);
    font-weight: bold;
  }
  span.label {
    display: inline-block;
    padding: 3px 15px;
    border-radius: 27px;
    color: #fff;
    font-size: 0.9em;
    font-weight: bold;
    background-color: rgb(252, 38, 39);
  }
  h3 {
    font-size: 1.6em;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  .benefits {
    display: flex;
    margin-bottom: 20px;
    ${mediaMax.laptop`
      flex-wrap: wrap;
    `}
    > ul.list {
      width: 50%;
      padding: 0;
      margin: 0;
      margin-right: 12px;
      ${mediaMax.phoneL`
        width: 100%;
      `}
      > li {
        list-style: none;
        padding: 0;
        margin: 0;
        background-size: 16px auto;
        font-size: 1.6em;
        line-height: 1.8;
        display: flex;
        align-items: baseline;
        em {
          color: ${colors.primary};
        }
        p {
          font-size: 0.9em;
        }
      }
      i {
        color: ${colors.primary};
        margin-right: 10px;
      }
    }
  }
  ${mediaMax.phoneL`
    padding: 15px;
    > section {
      padding-bottom: 15px;
      > a {
        margin-bottom: 10px;
        display: block;
        button {
          width: 100%;
          padding: 20px;
          font-size: 1.6em;
        }
      }
      p.note {
        font-size: 1.5em;
        font-style: italic;
        text-align: center;
        opacity: .6;
        margin-bottom: 15px;
      }
      div.hotelInfo {
        background: url(${bgWhite}) no-repeat top left;
        margin: 0 -15px;
        padding: 30px 15px 10px;
        p {
          font-size: 1.6em;
          margin-bottom: 10px;
        }
        div.hotelBenefits {
          padding: 20px;
          border-radius: 8px;
          background-color: #F4FAFF;
          .benefits {
            margin-bottom: 0;
          }
          h3 {
            margin-bottom: 10px;
          }
          ul.list {
            margin-bottom: 0px;
            li {
              line-height: 1.6;
            }
          }
          p {
            span {
              color: ${colors.primary};
            }
          }
        }
      }
    }
  `}
`;

FeaturedHotel.Row = styled.div`
  display: flex;
  > div {
    width: 50%;
  }
  > div:last-child {
    order: 1;
  }
  > div:first-child {
    order: 2;
    padding: 0 7em 2.5em;
    p {
      font-size: 1.8em;
      margin-bottom: 1.2em;
    }
    a {
      font-weight: bold;
    }
    button {
      font-size: 1.8em;
      padding: 0.75em 1em;
    }
  }
  @media (max-width: 991px) {
    flex-direction: column;
    > div {
      width: 100%;
      &:first-child {
        padding: 2em 0;
      }
    }
  }
`;

export const FeaturedHotelDetails = {};

FeaturedHotelDetails.Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid gray;
  > div.first-child {
    width: 50%;
    > div {
      display: inline-flex;
      align-items: center;
      @media (max-width: 991px) {
        flex-direction: column;
      }
    }
    h2 {
      font-size: 3.2em;
      font-weight: 600;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      @media (max-width: 991px) {
        order: 2;
      }
    }
    p {
      font-size: 1.8em;
    }
  }
  > div.last-child {
    width: 50%;
    text-align: right;
    > div {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      ${mediaMax.phone`
        justify-content: flex-start;
      `};
      h6 {
        font-size: 1.5em;
        font-style: italic;
        opacity: 0.6;
      }
      h4 {
        font-size: 1.8em;
        font-weight: 600;
        margin-right: 10px;
      }
      h3 {
        font-size: 1.8em;
        opacity: 0.6;
        text-decoration: line-through;
        text-transform: initial;
        font-weight: normal;
        margin: 0;
      }
      h2 {
        font-size: 2.7em;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-end;
        @media (max-width: 480px) {
          font-size: 2em;
        }
        small {
          margin-right: 10px;
          font-size: 0.6em;
          font-weight: bold;
        }
        span {
          color: ${colors.primary};
        }
      }
      &.first-child {
        @media (max-width: 480px) {
          padding: 10px 0;
        }
      }
    }
  }

  .deals {
    flex-direction: column !important;
    align-items: flex-end !important;
    @media (max-width: 767px) {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
  .deal {
    display: flex;
    flex-wrap: wrap;
  }
  ${mediaMax.phoneL`
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 0;
    border: none;
    > div.first-child {
      width: 55%;
      h2 {
        font-size: 2.4em;
        line-height: 1.3;
        margin-bottom: 10px;
        span {
          order: 2;
        }
        small {
          order: 1;
          margin-bottom: 5px;
        }
      }
      p {
        line-height: 1.3;
        font-size: 1.6em;
      }
    }
    > div.last-child {
      width: 45%;
      > div {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        h2 {
          font-size: 10px;
          margin-bottom: 10px;
          line-height: 1.2;
          small {
            font-size: 1.5em;
            margin: 0;
            font-weight: normal;
            strong {
              font-weight: bold;
            }
          }
        }
        h3 {
          font-size: 1.5em;
          opacity: .6;
          line-height: 1.3;
        }
        .thb {
          text-align: center;
          max-width: 160px;
          margin-bottom: 5px;
          > div:first-child {
            font-size: 2.3em;
            font-weight: bold;
            background-color: #E4FCF7;
            border-radius: 8px 8px 0 0;
            padding: 3px;
            span {
              color: ${colors.primary};
            }
          }
          div:last-child {
            color: #FFF;
            background: ${colors.primary};
            font-size: 1.5em;
            font-weight: bold;
            padding: 1px 6px;
          }
        }
      }
    }
  `}
`;

FeaturedHotelDetails.Pill = styled.div`
  border-radius: 20px;
  display: inline-block;
  padding: 0.2em 0.8em;
  font-size: 1.6em;
  font-weight: bold;
  color: #ffffff;
  background-color: #202b36;
  margin-right: 10px;
  ${mediaMax.phone`
    font-size: 14px;
  `};
`;

export const FeaturedHotelSlider = {};

FeaturedHotelSlider.Wrapper = styled.div`
  .owl-carousel {
    margin-bottom: 25px;
    position: relative;
    .owl-stage > .owl-item > div {
      height: 469px;
      background-color: #f1f1f1;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 480px) {
        height: 280px;
      }
    }
    .owl-nav {
      position: absolute;
      top: 50%;
      left: 10px;
      right: 10px;
      transform: translateY(-50%);
      display: flex;
      justify-content: space-between;
      .owl-prev,
      .owl-next {
        width: 32px;
        height: 32px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 32px;
        cursor: pointer;
      }
    }
  }
  > section {
    position: relative;
    > h3 {
      text-align: center;
      width: 100%;
      max-width: 414px;
      font-weight: 600;
      position: absolute;
      color: #1a283e;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 10;
      background-color: ${colors.primary};
      font-size: 14px;
      padding: 0.5em 0.7em;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
  }
  > ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  ${mediaMax.phoneL`
    > section {
      > h3 {
        width: calc(100% - 40px);
        font-size: 1.4em;
      }
    }
  `}
`;

FeaturedHotelSlider.Thumbnail = styled.div`
  width: calc((100% / 8) - 10px);
  margin-right: 10px;
  opacity: 0.5;
  transition: all 0.2s;
  ${(props) =>
    props.active &&
    `
    opacity: 1;
  `}
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    opacity: 1;
  }
  button {
    display: block;
    cursor: pointer;
    padding: 0;
    -webkit-box-shadow: 0px 1px 36px -12px rgba(0, 0, 0, 0);
    -moz-box-shadow: 0px 1px 36px -12px rgba(0, 0, 0, 0);
    box-shadow: 0px 1px 36px -12px rgba(0, 0, 0, 0);
    transition: all 0.25s;
    width: 100%;
    height: 100%;
    &:hover {
      -webkit-box-shadow: 0px 1px 36px -12px rgba(0, 0, 0, 0.15);
      -moz-box-shadow: 0px 1px 36px -12px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 1px 36px -12px rgba(0, 0, 0, 0.15);
    }
    img {
      width: 100%;
      height: auto;
    }
  }
`;

export const Quotes = {};

Quotes.Wrapper = styled.div`
  padding: 0 30px;
  border-top: 2px solid #95ebd7;
  > div {
    margin: 0 auto;
    font-size: 10px;
    .blockquote {
      border-left: solid 1px #95ebd7;
      padding: 0 15px 0 15px;
      position: relative;
      margin: 0;
      display: flex !important;
      flex-direction: column;
      justify-content: space-between;
      &:before {
        content: '';
        position: absolute;
        left: -35px;
        background: url(${iconQuote}) no-repeat center center;
        width: 27.25px;
        height: 20.18px;
      }
      h2 {
        font-size: 2.5em;
        font-style: italic;
        line-height: 1.5;
        color: #1a283e;
      }
      .rating {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        p {
          font-size: 16px;
          text-transform: uppercase;
          margin-right: 10px;
          font-weight: 600;
          color: #1a283e;
        }
        .star {
          background: url(${iconStar}) no-repeat center;
          background-size: cover;
          width: 53px;
          height: 50px;
          align-items: center;
          justify-content: center;
          display: flex;
          h3 {
            font-size: 17px;
            color: #fff;
          }
        }
      }
    }
  }
  ${mediaMax.laptop`
    > div {
      .blockquote {
        br {
          display: none;
        }
      }
    }
  `};
  ${mediaMax.tablet`
    padding-top: 0;
    > div {
      .blockquote {
       h2{
        font-size: 2.4em;
       }
      }
    }
  `};
  .ant-carousel {
    .slick-slider {
      .slick-list {
        padding-top: 35px;
        .slick-track {
          display: flex;
          .slick-slide {
            padding: 0 0 0 35px;
            float: none !important;
            height: auto;
            align-self: stretch;

            > div {
              height: 100%;
              > .blockquote {
                height: 100%;
              }
            }
          }
        }
      }
      .slick-dots {
        position: static;
        padding-top: 15px;
        li {
          button {
            background-color: ${colors.primary};
          }
        }
        li.slick-active {
        }
      }
    }
  }
  ${mediaMax.phoneL`
    border: none;
    padding: 0 15px;
    > div {
      flex-wrap: wrap;
      .blockquote {
        width: 100%;
        border: none;
        padding: 0; margin: 0;
        justify-content: flex-start;
        h2 {
          font-size: 2em;
        }
        &:before {
          display: none;
        }
      }
    }
    .ant-carousel {
      .slick-slider {
        .slick-list {
          padding: 0;
          .slick-track {
            display: flex;
            .slick-slide {
              padding: 30px 15px 15px;
            }
          }
        }
        .slick-dots {
          height: 52px;
          background-color: #F4FAFF;
          border-top: solid 1px #E8E9EB;
          padding: 0;
          > li {
            margin-top: 24px;
            button {
              background-color: #1A283E;
              opacity: .4;
            }
          }
          > li.slick-active {
            button {
              opacity: 1;
            }
          }
        }
      }
    }
  `};
`;

Quotes.Container = styled(Container)`
  padding: 30px 0 50px;
  position: relative;
  ${mediaMin.tablet`
    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: -40px;
      left: 0;
      border-left: 0px solid transparent;
      border-right: 54px solid transparent;
      border-bottom: 40px solid #95ebd7;
      z-index: 1;
    }
    &:after {
      content: '';
      position: absolute;
      width: 10px;
      height: 46px;
      border-left: 0px solid transparent;
      border-right: 50px solid transparent;
      border-bottom: 37px solid #fff;
      top: -46px;
      left: 1px;
      z-index: 2;
    }
  `}
  ${mediaMax.phoneL`
    position: relative;
    padding: 0;
    border: 1px solid #77EED6;
    margin-bottom: 20px!important;
    z-index: 5;
    > .btn-arrows {
      .btn {
        width: 32px;
        height: 32px;
        background-color: rgba(26,40,62,.05);
        border-radius: 24px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        bottom: 9px;
        z-index: 10;
        &.left {
          left: 15px;
        }
        &.right {
          right: 15px;
        }
      }
    }
    &:before {
      content: "";
      position: absolute;
      top: -18px; left: 15px;
      background: url(${iconQuote}) no-repeat center center;
      background-size: 39px 31px;
      width: 39px;
      height: 31px;
    }
  `}
`;

export const Rooms = {};

Rooms.Wrapper = styled.section`
  padding: 30px;
  background-image: url(${bgHotels});
  background-size: cover;
  background-position: center;
  border-top: solid 1px ${colors.primary};
  > h2 {
    font-size: 4.2em;
    font-weight: bold;
    margin-bottom: 5px;
    text-align: center;
    text-transform: uppercase;
  }
  > p {
    font-size: 2.1em;
    margin-bottom: 47px;
    text-align: center;
  }
  > button {
    width: 100%;
  }
  .reminder {
    font-size: 1.8em;
    text-align: center;
    span {
      color: ${colors.primary};
    }
  }
  ${mediaMax.phoneL`
    padding: 45px 15px 30px;
    > h2 {
      font-size: 2.5em;
      text-align: left;
    }
    p {
      font-size: 1.6em;
      text-align: left;
      margin-bottom: 15px;
    }
  `}
`;

Rooms.Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin: 0 auto;
  justify-content: space-between;
  ${mediaMax.phoneL`
    padding: 0;
  `}
`;

export const Room = {};

Room.Wrapper = styled.div`
  width: calc(33.333333% - 25px);
  margin-bottom: 30px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  .owl-carousel {
    display: block;
    height: auto;
    position: relative;
  }
  .owl-stage-outer {
    height: inherit;
  }
  .owl-dots {
    display: flex;
    position: absolute;
    bottom: 5%;
    width: 100%;
    justify-content: center;
    align-items: center;
    .owl-dot {
      width: 8px;
      height: 8px;
      margin: 5px 2px;
      background-color: #ffffff24;
      border-radius: 50%;
    }
    .active {
      width: 8px;
      height: 8px;
      background-color: #ffffff;
    }
  }
  > .img {
    width: 100%;
    height: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    .save {
      font-size: 1.5em;
      font-weight: bold;
      color: #fff;
      text-transform: uppercase;
      background-color: #fc2627;
      padding: 0px 8px;
      display: inline-block;
      border-radius: 22px;
      position: absolute;
      right: 8px;
      top: 10px;
      z-index: 2;
    }
  }
  > .caption {
    padding-top: 10px;
    padding-bottom: 15px;
    h4 {
      font-size: 2em;
      font-weight: bold;
      line-height: 1.2;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      div {
        span {
          color: ${colors.primary};
        }
      }
    }
    h5 {
      font-size: 1.8em;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 10px;
      strong {
        text-transform: uppercase;
        font-size: 0.9em;
      }
      strike {
        opacity: 0.6;
        display: inline-block;
      }
    }
    .details {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      min-height: 200px;
      h3 {
        font-size: 1.8em;
      }
      p {
        font-size: 1.8em;
        font-weight: 400;
        margin-bottom: 5px;
        position: relative;
        padding-left: 25px;
        &:before {
          display: inline-block;
          content: ' ';
          height: 7px;
          width: 7px;
          border-radius: 50%;
          background: ${colors.primary};
          margin-left: -25px;
          margin-top: 9px;
          position: absolute;
          z-index: 2;
        }
      }
    }
    p {
      font-size: 1.6em;
      font-weight: bold;
      color: #1a283e;
      margin-bottom: 15px;
      ${mediaMin.laptop`
        margin-bottom: 30px;
      `};
    }
    .reserve {
      width: 100%;
    }
    .warning {
      color: #fc2627;
      text-transform: uppercase;
    }
    .price {
      font-size: 2.8em;
      font-weight: bold;
      margin-bottom: 5px;
      small {
        font-size: 0.8em;
        font-weight: 400;
        text-decoration: line-through;
        opacity: 0.6;
      }
    }
  }
  ${mediaMax.laptop`
    width: calc(50% - 25px);
  `};
  ${mediaMax.tablet`
    width: calc(50% - 15px);
    &.book-now {
      .img {
        width: 100%;
        min-height: 200px;
      }
    }
  `};
  ${mediaMax.phoneL`
    width: 100%;
    flex-wrap: wrap;
    background: #FFF;
    border-radius: 8px 0 8px 0;
    border: 1px solid #77EED6;
    > .img,
    > .caption {
      width: 100%;
    }
    > .img {
      height: auto;
      min-height: auto;
    }
    > .caption {
      padding: 0 0 15px;
      a {
        button {
          width: calc(100% - 30px)!important;
          margin: 15px 15px 0;
          display: block;
          padding: 15px;
          text-transform: uppercase;
        }
      }
    }
    > .caption.top {
      padding: 15px;
      h4 {
        font-size: 1.8em;
        line-height: 1.1;
        margin: 0;
        div:last-child {
          font-size: .9em;
        }
      }
      h5 {
        font-size: 1.7em;
        margin: 0;
      }
    }
    > .img {
      min-height: 150px;
    }
    &.book-now {
      .img {
        min-height: 150px;
      }
    }
  `};
`;

Room.Control = styled.button`
  height: 32px;
  width: 32px;
  border-radius: 24px;
  background-color: #ffffff;
  padding: 0;
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  i {
    color: #1a283e;
    font-size: 15px;
    font-weight: 600;
  }
  ${(props) =>
    props.right &&
    `
    right: 0;
    left: auto;
  `}
`;

Room.Info = styled.div`
  button {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px rgba(26, 40, 62, 0.1);
    padding: 10px 15px;
    span {
      font-size: 1.7em;
    }
    i.fas {
      opacity: 0.6;
    }
  }
  .details {
    padding: 15px;
  }
`;

export const PartnerHotels = {};

PartnerHotels.Wrapper = styled.div``;

PartnerHotels.Container = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 30px;
  ${mediaMax.phoneL`
    padding: 0 15px;
  `}
`;

PartnerHotels.Header = styled(PageHeader)`
  background: #999 url(${bgBlue});
  background-position: top center;
  padding: 100px 30px;
  h1 {
    font-size: 4.2em;
    line-height: 1.2;
  }
  p {
    font-size: 2.1em;
    text-transform: none;
  }
  ${mediaMax.tablet`
    h1 {
      font-size: 3.2em;
    }
    p {
      font-size: 1.8em;
    }
  `}
  ${mediaMax.phoneL`
    text-align: left;
    padding: 30px 15px 75px;
    h1 {
      font-size: 2.5em;
    }
    p {
      font-size: 1.6em;
    }
  `}
`;

PartnerHotels.MapWrapper = styled.div`
  background: #fff;
  border-radius: 2px;
  height: 100%;
  position: relative;
  height: 500px;
  width: 100%;
  border: solid 1px ${colors.primary};
  border-radius: 2px;
  margin-top: -50px;
  .gm-style-iw.gm-style-iw-c {
    border-radius: 0 !important;
    max-height: none !important;
    padding: 0 !important;
  }
  .gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
  }
  button.gm-ui-hover-effect {
    display: none !important;
  }
`;

PartnerHotels.Map = styled.div``;

PartnerHotels.InfoWindow = styled.div`
  max-width: 230px;
  height: auto;
  padding: 10px 10px 15px;
  img {
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  button {
    color: #fff;
    font-size: 1.2em;
    text-align: center;
    padding: 4px 10px;
    cursor: pointer;
    border-radius: 28px;
    background-color: ${colors.primary};
  }
`;

PartnerHotels.Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  h3 {
    font-size: 2.3em;
    font-weight: bold;
  }
  select {
    font-size: 1.6em;
    line-height: 1.6;
    border-radius: 1px;
    border: 1px solid rgba(26, 40, 62, 0.1);
    height: 50px;
  }
  > div {
    display: flex;
    align-items: center;
    h3 {
      margin-right: 15px;
    }
  }
  ${mediaMax.phoneL`
    display: block;
    padding: 15px 0;
    > h3 {
      display: none;
    }
    > div {
      display: flex;
      background: #77EED6;
      border-radius: 2px 2px 0 0;
      border: 1px solid #77EED6;
      h3 {
        margin: 0;
        width: 90px;
        font-size: 1.6em;
        text-align: center;
        padding: 0 15px;
      }
      select {
        width: calc(100% - 90px);
        flex-grow: 1;
        border: none;
        background: #FFF;
      }
    }
  `}
`;

PartnerHotels.Hotels = styled.div`
  > p {
    text-align: center;
    font-size: 1.6em;
    margin-bottom: 30px;
  }
  ${mediaMax.phoneL`
    > p {
      opacity: .6;
      font-size: 1.5em;
    }
  `}
`;

PartnerHotels.List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Hotel = {};

Hotel.Wrapper = styled.div`
  border: 1px solid ${colors.primary};
  padding: 8px;
  border-radius: 2px;
  margin-bottom: 25px;
  display: flex;
  ${mediaMax.laptop`
    padding-right: 0;
  `}
  ${mediaMax.phoneL`
    flex-wrap: wrap;
    padding-right: 8px;
  `}
`;

Hotel.Slider = styled.div`
  width: 345px;
  position: relative;
  ${mediaMax.phoneL`
    width: 100%;
  `}
  > .btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 200;
    height: 32px;
    width: 32px;
    border-radius: 24px;
    background-color: #ffffff;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
    i {
      color: #1a283e;
      font-size: 15px;
      font-weight: 600;
    }
    &.left {
      left: 5px;
    }
    &.right {
      right: 5px;
    }
  }
  .ant-carousel {
    height: 100%;
    z-index: 100;
    .slick-slider {
      height: 100%;
      .slick-list {
        height: 100%;
        .slick-track {
          height: 100%;
          .slick-slide {
            div {
              height: 100%;
            }
            .bgSlide {
              background-size: cover;
              background-position: center center;
              ${mediaMax.phoneL`
                 min-height: 200px;
              `}
            }
          }
        }
      }
      ul.slick-dots {
        height: 8px;
        bottom: 10px;
        li {
          button {
            width: 8px;
            height: 8px;
            border-radius: 8px;
          }
        }
      }
    }
  }
  
  .save{
    font-size: 1.5em;
    font-weight: bold;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    background-color: rgb(252, 38, 39);
    display: inline-block;
    position: absolute;
    right: 8px;
    top: 10px;
    z-index: 2;
    padding: 0px 8px;
    border-radius: 22px;
  }
`;

Hotel.InfoPrices = styled.div`
  flex-grow: 1;
  display: flex;
  ${mediaMin.laptop`
    padding: 15px 20px 15px 30px;
  `}
  ${mediaMax.laptop`
    flex-wrap: wrap;
  `}
`;

Hotel.Stars = styled.small`
  font-size: 0.6em;
  i {
    margin-right: 5px;
    color: ${colors.primary};
  }
`;

Hotel.Info = styled.div`
  ${mediaMin.laptop`
    flex-grow: 1;
    width: calc(100% - 320px);
  `}
  ${mediaMax.laptop`
    padding: 15px;
    width: 100%;
    border-bottom: 1px solid ${colors.primary};
  `}
  h3 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 2.6em;
    font-weight: bold;
    margin-bottom: 15px;
    span {
      margin-right: 10px;
    }
  }
  p {
    font-size: 1.6em;
    margin-bottom: 15px;
  }
`;

Hotel.PerfectFor = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  p {
    font-size: 1.6em;
    margin: 0;
  }
  ul {
    margin: 0;
    padding: 0;
    font-size: 1.6em;
    li {
      margin: 0;
      padding: 0;
      list-style: none;
      border: 1px solid rgba(26, 40, 62, 0.1);
      background-color: #f4faff;
      padding: 2px 6px;
      font-size: 1em;
      text-transform: uppercase;
      margin-left: 10px;
      display: inline-block;
    }
  }
`;

Hotel.Prices = styled.div`
  .rating {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 135px;
    p {
      margin: 0;
      text-align: right;
      font-size: 1.4em;
      strong {
        font-size: 1.2em;
      }
    }
    h5 {
      margin-left: 10px;
      font-size: 2.3em;
      width: 53px;
      height: 53px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFF;
      background-color: #272F72;
      border-radius: 10px 0 10px 0;
    }
  }
  h3.price {
    display: inline-flex;
    align-items: center;
    font-size: 2em;
    font-weight: bold;
    small {
      margin-right: 5px;
      font-weight: 400;
    }
    span {
      color: ${colors.primary};
    }
  }
  div.save {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 15px;
    label {
      color: #FFF;
      background-color: #1A283E;
      font-size: 1.5em;
      line-height: 1;
      font-weight: bold;
      text-transform: uppercase;
      display: inline-block;
      padding: 5px 10px;
      border-radius: 25px;
      margin-right: 10px;
    }
    span {
      font-size: 2em;
      opacity: .6;
      text-decoration: line-through;
    }
  }
  ${mediaMin.laptop`
    width: 320px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .rating {
      margin-bottom: 15px;
    }
  `}
  ${mediaMax.laptop`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 15px;
    button.btnView {
      span {
        display: none;
      }
    }
  `}
  ${mediaMax.phoneL`
    justify-content: flex-end;
  `}
`;

Hotel.PopOver = styled(Modal)`
  &.ant-modal {
    color: #1a283e;
    .ant-modal-content {
      border: 1px solid rgba(151, 151, 151, 0.15);
      box-shadow: -7px 21px 35px 0 rgba(12, 0, 51, 0.04);
      .ant-modal-body {
        position: relative;
        background: url(${border}) no-repeat top center;
        background-size: 100% auto;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        .asterisk {
          color: ${colors.primary};
        }
        > button.close {
          position: absolute;
          top: 30px;
          right: 30px;
          font-size: 3em;
          font-weight: bold;
          opacity: 0.3;
          line-height: 1;
          cursor: pointer;
          &.hover {
            opacity: 0.6;
          }
        }
        h3 {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          font-size: 2.6em;
          font-weight: bold;
          margin-bottom: 5px;
          span {
            margin-right: 10px;
          }
        }
        > div {
          margin-bottom: 5px;
        }
        h6 {
          font-size: 1.6em;
          font-weight: bold;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        > p {
          font-size: 1.6em;
          margin-bottom: 5px;
        }
      }
    }
  }
`;

Hotel.PopOverMobile = styled(Modal)`
  &.ant-modal {
    margin: 0;
    max-width: 100%;
    padding: 0;
    position: relative;
    height: 100%;
    > .ant-modal-content {
      min-height: 100%;
      padding-bottom: 56px;
      .ant-modal-header {
        position: fixed;
        width: 100%;
        background: #fff url(${borderModal}) no-repeat bottom center;
        background-size: 100% 5px;
        padding: 15px 15px 20px;
        border: none;
        border-radius: 0;
        z-index: 500;
        .ant-modal-title {
          h2 {
            font-size: 1.8em;
            font-weight: bold;
            text-align: center;
            margin: 0;
          }
          button {
            position: absolute;
            top: 50%;
            left: 15px;
            transform: translateY(-50%);
            padding: 5px;
          }
        }
      }
      .ant-modal-body {
        padding: 57px 0 0;
        position: relative;
        z-index: 400;
        .asterisk {
          color: ${colors.primary};
        }
        .content-wrapper {
          font-size: 10px;
          padding: 15px;
          color: #1a283e;
          > .stars {
            font-size: 2em;
          }
          > h3 {
            font-size: 2.6em;
            font-weight: bold;
            line-height: 1.3;
            margin-bottom: 5px;
          }
          > p {
            font-size: 1.5em;
            margin-bottom: 10px;
          }
          > p.lead {
            text-transform: uppercase;
            font-weight: bold;
          }
          > .perfectfor {
            ul {
              li {
                margin: 0;
                margin-right: 5px;
                font-size: 0.9em;
                text-transform: none;
              }
            }
          }
          > hr {
            margin: 0;
            border: none;
            border-bottom: solid 1px rgba(26, 40, 62, 0.1);
            margin-bottom: 15px;
          }
        }
        > p {
          font-size: 1.5em;
          text-align: center;
          opacity: 0.6;
          padding: 0 15px;
        }
        > a {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          button {
            width: 100%;
          }
        }
      }
    }
  }
`;

Hotel.AmenitiesWrapper = styled.div`
  border: 0.9px solid rgba(26, 40, 62, 0.1);
  background-color: rgba(244, 250, 255, 0.43);
  margin-bottom: 20px !important;
  padding: 20px 20px 15px;
  border-radius: 2px;
  > p {
    font-size: 1.2em;
    font-weight: bold;
    text-transform: uppercase;
    opacity: 0.8;
  }
`;

Hotel.Amenities = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

Hotel.Amenity = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 10px;
  img {
    width: auto;
    height: auto;
    max-width: 22px;
    max-height: 22px;
    margin-right: 5px;
  }
  span {
    font-size: 1.4em;
    opacity: 0.8;
  }
  ${mediaMax.phoneL`
    margin: 0 0 10px;
    width: 50%;
    justify-content: space-between;
    align-items: baseline;
    span {
      width: calc(100% - 30px);
    }
  `}
`;

Hotel.Rooms = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-top: solid 1px rgba(26, 40, 62, 0.14);
  padding: 20px 0 0;
`;

Hotel.Room = styled.div`
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  > .image {
    width: 45%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  > .info {
    width: 55%;
    padding: 0 10px;
    h4 {
      font-size: 1.6em;
      font-weight: bold;
      margin-bottom: 0;
      line-height: 1.2;
    }
    .warning {
      color: #fc2627;
      font-size: 1.2em;
      font-weight: bold;
      margin-bottom: 5px;
    }
    label {
      display: inline-block;
      font-size: 1.2em;
      font-weight: bold;
      color: #fff;
      text-transform: uppercase;
      background-color: #1a283e;
      padding: 1px 6px;
      border-radius: 10px;
      margin-bottom: 5px;
    }
    p {
      font-size: 1.6em;
      font-weight: bold;
      margin-bottom: 0;
      strike {
        opacity: 0.6;
      }
    }
    .price {
      line-height: 1.2;
      span {
        color: ${colors.primary};
      }
    }
  }
  ${mediaMax.phoneL`
    width: 100%;
    > .image,
    > .info {
      min-height: 150px;
    }
  `}
`;

Hotel.RoomsMobile = styled.div``;

Hotel.RoomMobile = styled.div`
  border: 1px solid rgba(125, 197, 236, 0.5);
  border-radius: 2px;
  color: #1a283e;
  margin-bottom: 10px;
  > div {
    display: flex;
    border-bottom: 1px solid rgba(125, 197, 236, 0.5);
    > .image {
      width: 105px;
      height: 95px;
      border-radius: 2px 0 0 0;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
    > .info {
      width: calc(100% - 105px);
      position: relative;
      padding: 10px;
      h4 {
        font-size: 1.8em;
        font-weight: bold;
        margin: 0;
      }
      p.price {
        font-size: 1.8em;
        font-weight: bold;
        margin: 0;
        strike {
          font-size: 0.9em;
          opacity: 0.6;
          font-weight: 400;
        }
        span {
          color: ${colors.primary};
        }
      }
      label {
        position: absolute;
        top: 10px;
        right: 0;
        font-size: 1.4em;
        font-weight: bold;
        line-height: 1;
        color: #fff;
        background: ${colors.primary};
        padding: 3px 6px;
        border-radius: 2px 0 0 2px;
      }
      .warning {
        color: #fc2627;
        font-size: 1.2em;
        font-weight: bold;
        margin-bottom: 0;
      }
    }
  }
`;

export const HotelMobile = {};

HotelMobile.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #77eed6;
  border-radius: 2px;
  margin-bottom: 15px;
  
  .save {
    font-size: 1em;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    background-color: #fc2627;
    padding: 0px 8px;
    display: inline-block;
    border-radius: 22px;
    position: absolute;
    right: 8px;
    top: 10px;
    z-index: 2;
  }
`;

HotelMobile.Info = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #77eed6;
  padding: 10px;
  > .image {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 112px;
    height: 112px;
    position: relative;
    margin-left: -25px > span {
      position: absolute;
      top: 5px;
      left: 0;
      font-size: 1.4em;
      background: ${colors.primary};
      color: #fff;
      line-height: 1;
      padding: 3px 6px;
      border-radius: 0 2px 2px 0;
    }
  }
  > .details {
    width: calc(100% - (112px - 15px));
    position: relative;
    > img {
      position: absolute;
      top: 0;
      right: -20px;
      width: 34px;
      height: 28px;
    }
    h5 {
      margin-bottom: 5px;
      font-size: 1.4em;
      small {
        font-size: 0.9em;
      }
    }
    h3 {
      font-size: 1.8em;
      font-weight: bold;
      line-height: 1.2;
      margin-bottom: 5px;
    }
    p {
      font-size: 1.4em;
      margin-bottom: 5px;
    }
    .perfectfor {
      margin: 0;
      ul {
        font-size: 10px;
        li {
          padding: 1px 5px;
          margin: 0 5px 5px 0;
          font-size: 1.4em;
          text-transform: none;
        }
      }
    }
  }
`;

HotelMobile.Price = styled.div`
  display: flex;
  background-color: #f4faff;
  justify-content: space-between;
  align-items: center;
  h3 {
    flex-grow: 1;
    text-align: center;
    font-size: 10px;
    padding: 5px;
    small {
      font-size: 1.2em;
    }
    strong {
      font-size: 1.5em;
      span {
        color: ${colors.primary};
      }
    }
    strike {
      font-size: 1.4em;
      opacity: 0.6;
    }
  }
  button {
    padding: 10px 15px;
    font-size: 1.4em;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    width: auto;
    background: ${(props) => props.theme.primary};
  }
`;

Hotel.ButtonLink = styled(Button)`
  width: 100%;
  padding: 15px 30px;
  text-transform: uppercase;
  margin-bottom: 15px;
`;



// WEBPACK FOOTER //
// ./src/containers/Hotel/styles.js